import { useMemo } from 'react';
import { useStore } from '~/store/store-context';
import { getVisibleNotifications } from '~/types/api/in-app-notifications.utils';
const EMPTY_NOTIFICATIONS = [];
export const useVisibleNotifications = ()=>{
    const data = useStore((state)=>state.inAppNotifications.data);
    return useMemo(()=>getVisibleNotifications(data !== null && data !== void 0 ? data : EMPTY_NOTIFICATIONS), [
        data
    ]);
};
